import { Globe, Save, Info } from "lucide-react";
import { validateCabinet } from "./validators.js";
import ActionRequiredBanner from "./ActionRequiredBanner.jsx";

const PORTAL_FIELDS = ["contact_email", "contact_phone", "default_portal_link_text"];

export default function PortailSection({ settings, update, onSave }) {
  const errors = validateCabinet(settings);
  const hasError = !!errors.contact_email;

  return (
    <div className="bg-white border rounded-xl p-5 space-y-4" data-testid="portail-section">
      <h3 className="font-semibold text-sm flex items-center gap-2">
        <Globe className="w-4 h-4" /> Parametres du portail client
      </h3>
      {/* Batch #14.52 — Bannière action requise pour le Portail (recommandations) */}
      <ActionRequiredBanner
        sectionKey="portal"
        title="Suggestion d'amélioration"
      />
      <p className="text-xs text-gray-500">
        Ces infos sont affichees dans le portail client (en-tete, contact, courriels).
      </p>

      <div>
        <label className="block text-sm font-medium mb-1">Courriel de contact (portail client)</label>
        <input type="email" value={settings.contact_email || ""}
          onChange={e => update("contact_email", e.target.value)}
          className={`w-full border rounded-lg px-3 py-2 text-sm ${errors.contact_email ? "border-red-300 bg-red-50" : ""}`}
          placeholder="info@entreprise.ca" data-testid="settings-contact-email" />
        {errors.contact_email && <p className="text-xs text-red-500 mt-0.5">{errors.contact_email}</p>}
        <p className="text-[10px] text-gray-400 mt-0.5">
          Bouton "Contacter" dans le portail client pointera vers cette adresse.
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Telephone de contact (affichage portail)</label>
        <input type="text" value={settings.contact_phone || ""}
          onChange={e => update("contact_phone", e.target.value)}
          className="w-full border rounded-lg px-3 py-2 text-sm" placeholder="(514) 555-1234"
          data-testid="settings-contact-phone" />
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">
          Gabarit : message d'invitation au portail
        </label>
        <textarea rows={4} value={settings.default_portal_link_text || ""}
          onChange={e => update("default_portal_link_text", e.target.value)}
          className="w-full border rounded-lg px-3 py-2 text-sm"
          placeholder="Bonjour, voici le lien vers votre portail securise. Vos identifiants vous seront envoyes separement..."
          maxLength={1000} data-testid="settings-portal-link-text" />
        <p className="text-[10px] text-gray-400 mt-0.5">
          Ce texte est insere par defaut dans les communications envoyees au client.
        </p>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-xs text-blue-800 flex items-start gap-2">
        <Info className="w-4 h-4 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-medium">Gestion des acces</p>
          <p>Pour activer / desactiver un compte client ou reinitialiser un mot de passe, utilisez le module
            <a href="/admin/portail-clients" className="underline ml-1">Cabinet → Portail clients</a>.
          </p>
        </div>
      </div>

      <button onClick={() => onSave(PORTAL_FIELDS)} disabled={hasError}
        className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-700 disabled:opacity-50 flex items-center gap-2"
        data-testid="settings-save-portal">
        <Save className="w-4 h-4" /> Sauvegarder
      </button>
    </div>
  );
}
